import { render, staticRenderFns } from "./MemberFired.vue?vue&type=template&id=52a468a7&"
import script from "./MemberFired.vue?vue&type=script&lang=js&"
export * from "./MemberFired.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports